import { render, staticRenderFns } from "./avs.vue?vue&type=template&id=1e532f38&scoped=true&"
import script from "./avs.vue?vue&type=script&lang=js&"
export * from "./avs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e532f38",
  null
  
)

export default component.exports